import { render, staticRenderFns } from "./QRCodeShareModal.vue?vue&type=template&id=4a5069bb"
import script from "./QRCodeShareModal.vue?vue&type=script&lang=js"
export * from "./QRCodeShareModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports